import styled from 'styled-components';

export const StatisticCont = styled.div`
  ${({ theme }) => `
    display: flex;
    gap: ${theme.layout.spacing.decy};
  `};
`;
